import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography, Chip } from "@mui/material";
import {
  Container,
  Button,
  Row,
  Col,
  Table,
  Form,
  Spinner,
  Modal,
} from "react-bootstrap";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

import { API_URL } from "../utils/config";
const QueryFragment = () => {
  const [queries, setQueries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    studentID: localStorage.getItem("userId"),
    createdBy: localStorage.getItem("userId"),
  });
  const [userType, setUserType] = useState(
    localStorage.getItem("type") || "employee"
  );

  const fetchQueries = async () => {
    setIsLoading(true);
    try {
      // Get the correct user ID based on user type
      const userId = localStorage.getItem("userId");
      const userType = localStorage.getItem("type");

      // Different endpoints for admin vs employee
      const endpoint =
        userType === "superadmin" || "bcom"
          ? `${API_URL}/admin/query-master`
          : `${API_URL}/admin/query-master/student/${userId}`;

      const response = await fetch(endpoint, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      if (response.status === 401) {
        localStorage.clear();
        window.location.reload();
        return;
      }

      const data = await response.json();
      setQueries(data);
    } catch (error) {
      console.error("Error fetching queries:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchQueries();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API_URL}/admin/query-master`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
          body: JSON.stringify(formData),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to create query");
      }
      setFormData({
        title: "",
        description: "",
        studentID: localStorage.getItem("userId"),
        createdBy: localStorage.getItem("userId"),
      });
      setShowModal(false);
      fetchQueries();
      alert("Query submitted successfully");
    } catch (error) {
      console.error("Error creating query:", error);
      alert("Error submitting query, please try again!");
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "open":
        return "warning";
      case "in-progress":
        return "info";
      case "resolved":
        return "success";
      default:
        return "default";
    }
  };

  return (
    <Container>
      <Paper elevation={3} style={{ padding: "20px", marginBottom: "20px" }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={8}>
            <Typography variant="h5">My Queries</Typography>
          </Grid>
          {/* Only show "Raise New Query" button for students (non-admin users) */}
          {userType !== "superadmin" &&
            userType !== "admin" &&
            userType !== "bcom" &&
            userType !== "owner" && (
              <Grid item xs={4} style={{ textAlign: "right" }}>
                <Button
                  variant="primary"
                  onClick={() => setShowModal(true)}
                  style={{
                    fontWeight: "600",
                    borderRadius: "20px",
                  }}
                >
                  Raise New Query
                </Button>
              </Grid>
            )}
        </Grid>
      </Paper>

      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <div style={{ width: "100%" }}>
          {queries.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Response</th>
                  <th>Created Date</th>
                </tr>
              </thead>
              <tbody>
                {queries.map((query) => (
                  <tr key={query._id}>
                    <td>{query.title}</td>
                    <td>{query.description}</td>
                    <td>
                      <Chip
                        label={query.status}
                        color={getStatusColor(query.status)}
                        size="small"
                      />
                    </td>
                    <td>{query.response || "-"}</td>
                    <td>{new Date(query.createdDate).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div style={{ margin: "20px", textAlign: "center" }}>
              No queries found. Raise a new query if you need assistance.
            </div>
          )}
        </div>
      )}

      {/* Modal for creating new query */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Raise New Query</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Button
              variant="primary"
              type="submit"
              disabled={isLoading}
              style={{
                fontWeight: "600",
                borderRadius: "20px",
              }}
            >
              {isLoading ? <Spinner size="sm" animation="border" /> : "Submit"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default QueryFragment;
